import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import Login from './components/Login';
import Home from './components/Home';
import Explorer from './components/Explorer';
import Admin from './components/Admin';

export const LanguageContext = React.createContext();

function App() {
  const isAuthenticated = useIsAuthenticated();
  const [language, setLanguage] = useState('fr');

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <Router>
        <Routes>
          <Route
            path="/"
            element={isAuthenticated ? <Navigate to="/home" /> : <Login />}
          />
          <Route
            path="/home"
            element={isAuthenticated ? <Home /> : <Navigate to="/" />}
          />
          <Route
            path="/explorer/:containerName"
            element={isAuthenticated ? <Explorer /> : <Navigate to="/" />}
          />
          <Route
            path="/admin"
            element={isAuthenticated ? <Admin /> : <Navigate to="/" />}
          />
        </Routes>
      </Router>
    </LanguageContext.Provider>
  );
}

export default App;